// Builder/constants/blockDefaults.ts

import { BlockStyle } from "../types/blockStyles";

export const defaultBlockStyle: BlockStyle = {
  top: 80,
  left: 80,
  width: 200,
  height: 100,
  position: "absolute",
  rotation: 0,
  opacity: 1,
  zIndex: 1,
  borderRadius: 6,
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  backgroundColor: "#ffffff",
};
